import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import GoogleOneTap from './GoogleOneTap';

const GoogleOneTapWrapper: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  // Pages where Google One Tap should be allowed (only unauthenticated pages)
  const allowedPages = ['/', '/pricing', '/privacy-policy', '/terms-of-service', '/contact'];
  const isAllowedPage = allowedPages.includes(location.pathname);

  // Only render GoogleOneTap if user is not logged in and we're on an allowed page
  if (!user && isAllowedPage) {
    return <GoogleOneTap />;
  }

  return null;
};

export default GoogleOneTapWrapper;